import { getApiBaseUrl } from '../lib/storefront/storeBootstrap';

/** Turns an API-relative upload path into an absolute URL; passes through absolute ones. */
export function resolveMediaUrl(value) {
    if (!value || typeof value !== 'string') return '';
    const trimmed = value.trim();
    if (!trimmed) return '';
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (/^(data:|blob:)/i.test(trimmed)) return trimmed;
    // Bundled frontend assets (e.g. CRA /static/media/...) — do not prefix with API base
    if (trimmed.startsWith('/static/') || trimmed.includes('/static/media/')) return trimmed;
    const base = getApiBaseUrl();
    if (!base) return trimmed;
    return trimmed.startsWith('/') ? `${base}${trimmed}` : `${base}/${trimmed}`;
}
